import { render, staticRenderFns } from "./Prenatals.vue?vue&type=template&id=79817098&scoped=true"
import script from "./Prenatals.vue?vue&type=script&lang=js"
export * from "./Prenatals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79817098",
  null
  
)

export default component.exports